import { useMutation, useQuery, useQueryClient } from "react-query";
import {
  deleteService,
  enableAndCreateAltumPersonService,
  getUsersService,
  updateProfilePictureService,
  getUsersServiceV1,
  disableAltumViewService,
  resendInvitationService,
  signUpService,
} from "./Users.service";
import { Alert } from "utils";

export const userKeys = {
  users: "users",
  caregivers: "caregivers"
};

export const useGetUsersQuery = (params) => {
  return useQuery([userKeys.users, params], ({ signal }) =>
    getUsersService({ signal, params })
  );
};
export const useGetUsersQueryV1 = () => {
  return useQuery(userKeys.users, ({ signal }) =>
    getUsersServiceV1({ signal })
  );
};

export const useUpdateProfilePictureMutation = () => {
  return useMutation(
    ({ identifier, file }) => updateProfilePictureService({ identifier, file }),
    {
      onError: () => Alert.error("Error while uploading profile picture"),
      onSuccess: () => Alert.success("Profile picture updated"),
    }
  );
};

export const useDeleteMutation = (isType) => {
  const dynamicUserKey = isType === "B2B" ? userKeys?.caregivers : userKeys?.users
  const queryClient = useQueryClient();
  return useMutation(
    ({ url, identifier }) => deleteService({ url }),
    {
      onSuccess: (data, { identifier }) => {
        Alert.success(data?.message);
        queryClient.setQueryData(dynamicUserKey, (old) =>
          old?.filter((x) => x.id !== identifier)
        );
      },
      onError: (error) => {
        // Alert.error(error?.data?.message);
      },
    }
  );
};

export const useEnableAndCreateAltumPersonMutation = () => {
  const queryClient = useQueryClient();

  return useMutation(
    (userId) => enableAndCreateAltumPersonService(userId),
    {
      onSuccess: (data) => {
        Alert.success(data?.message || "Person enabled and created in AltumView");
        queryClient.invalidateQueries(userKeys.users);
      },
      onError: (error) => {
        Alert.error(
          error?.response?.data?.message ||
            "Unable to enable and create the person in AltumView"
        );
      },
    }
  );
};
export const useDisableAltumViewMutation = () => {
  const queryClient = useQueryClient();

  return useMutation(
    (userId) => disableAltumViewService(userId),
    {
      onSuccess: (data) => {
        Alert.success(data?.message || "AltumView disabled successfully");
        queryClient.invalidateQueries(userKeys.users);
      },
      onError: (error) => {
        Alert.error(
          error?.response?.data?.message ||
            "Unable to disable AltumView"
        );
      },
    }
  );
};
export const useResendInvitationMutation = () => {
  return useMutation(
    (userId) => resendInvitationService(userId),
    {
      onSuccess: (data) => {
        if (data?.code === 0) {
          Alert.success(
            data?.message || "Invitation resent successfully"
          );
        } else {
          Alert.error(
            data?.message || "Unable to resend invitation"
          );
        }
      },
      onError: (error) => {
        Alert.error(
          error?.response?.data?.message ||
            "Unable to resend invitation"
        );
      },
    }
  );
};

export const useSignUpMutation = () => {
  const queryClient = useQueryClient();

  return useMutation((payload) => signUpService(payload), {
    onSuccess: (data) => {
      Alert.success(data?.message || "Individual subscription user created");
      queryClient.invalidateQueries(userKeys.users);
    },
  });
};